import React, { Component } from "react";
import { connect } from "react-redux";
import { hot } from "react-hot-loader";
import { toArray } from "lodash";
import schemas from "./content-types";
import { Box } from "@material-ui/core";
import Table from "../../Table";
import Toolbar from "../../Toolbar";
import { isGuest } from "../../../utils/misc";

class ContentTypeList extends Component {
  schema = {
    ref: "contentTypes",
    title: "Content Types",
    group: "Content Types",
    id: "contentTypes",
    type: "object",
    properties: {
      title: {
        type: "string",
        label: "Content Type",
        component: "text",
      },
    },
  };

  render() {
    const { history, match } = this.props;

    const allowedSchemas = isGuest() ? [schemas.pages] : toArray(schemas);
    return (
      <Box>
        <Toolbar>
          <div />
        </Toolbar>
        <Box p={4}>
          <Table
            schema={this.schema}
            data={allowedSchemas}
            onRowClick={(row) => history.push(`${match.url}/${row.id}`)}
          />
        </Box>
      </Box>
    );
  }
}

export default connect((state) => ({}), {})(hot(module)(ContentTypeList));
